import { dia, elementTools, ui } from '@joint/plus';
export function addElementTools(cellView) {
    var paper = cellView.paper;
    var cell = cellView.model;
    var padding = cell.getFramePadding();
    removeElementTools(paper);
    var freeTransform = new ui.FreeTransform({
        cellView: cellView,
        resizeGrid: cell.getResizeGrid(),
        allowRotation: false,
        padding: padding,
        theme: 'material'
    });
    freeTransform.on({
        'resize:start': function () {
            cellView.addTools(new dia.ToolsView({ tools: [new SizeLabel()] }));
        },
        'resize:stop': function () {
            cellView.addTools(toolsView);
        }
    });
    var toolsView = new dia.ToolsView({
        tools: [
            new elementTools.Remove({
                x: '100%',
                offset: { x: padding.right + 14, y: -padding.top - 14 },
                useModelGeometry: true,
                markup: [{
                        tagName: 'circle',
                        selector: 'button',
                        attributes: {
                            'r': 10,
                            'fill': '#0058FF',
                            'cursor': 'pointer'
                        }
                    }, {
                        tagName: 'path',
                        selector: 'icon',
                        attributes: {
                            'd': 'M -4 -4 4 4 M -4 4 4 -4',
                            'fill': 'none',
                            'stroke': '#FFFFFF',
                            'stroke-width': 2,
                            'pointer-events': 'none'
                        }
                    }]
            })
        ]
    });
    freeTransform.render();
    cellView.addTools(toolsView);
}
export function removeElementTools(paper) {
    paper.removeTools();
    ui.FreeTransform.clear(paper);
}
var SizeLabelWidth = 50;
var SizeLabelHeight = 24;
export var SizeLabel = dia.ToolView.extend({
    children: [{
            tagName: 'rect',
            selector: 'background',
            attributes: {
                'width': SizeLabelWidth,
                'height': SizeLabelHeight,
                'x': -SizeLabelWidth / 2,
                'rx': 2,
                'ry': 2,
                'fill': '#fff',
                'stroke': '#333',
                'stroke-width': 2
            }
        }, {
            tagName: 'text',
            selector: 'label',
            attributes: {
                'text-anchor': 'middle',
                'x': 0,
                'y': 17,
                'font-size': 13,
                'font-family': 'Roboto',
                'fill': '#333',
            }
        }],
    onRender: function () {
        this.renderChildren();
        this.update();
    },
    update: function () {
        var _a = this, groupEl = _a.el, relatedView = _a.relatedView;
        var product = relatedView.model;
        var _b = groupEl.children, textEl = _b[1];
        textEl.textContent = product.getCurrentSizeLabel();
        var bbox = product.getBBox();
        var _c = product.getFramePadding(), left = _c.left, right = _c.right, top = _c.top, bottom = _c.bottom;
        bbox.moveAndExpand({ x: -left, y: -top, width: left + right, height: top + bottom });
        groupEl.setAttribute('transform', "translate(".concat(bbox.x + bbox.width / 2, ", ").concat(bbox.y - SizeLabelHeight - 5, ")"));
    }
});
